import ReduxHelper, { GenericItemReducerAction } from '../../common/store/ReduxHelper';
import { GroceryListShare, GroceryListShareAction, GroceryListShareState, GROCERY_LIST_SHARE_STORE } from './GroceryListShareTypes';

const defaultState: GroceryListShareState = ReduxHelper.getItemReducerDefaultState(GROCERY_LIST_SHARE_STORE);

const reducer = (state = defaultState, action: GroceryListShareAction): GroceryListShareState => ReduxHelper.caseItemDefaultReducer(state, action as GenericItemReducerAction<GroceryListShare>, defaultState);

export default reducer;
